// src/hooks/useAuth.ts

import { useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { LoginCredentials, RegisterData } from "../types/auth";
import { authApi } from "../api/auth";
import { clearAuthSession } from "../utils/authSession";

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const login = useCallback(
    async (credentials: LoginCredentials) => {
      try {
        context.setIsLoading(true);
        // پاسخ API را به درستی دیساختاردهی می‌کنیم
        const { access_token, user } = await authApi.login(credentials);

        localStorage.setItem("access_token", access_token); // ذخیره با کلید جدید
        localStorage.setItem("user", JSON.stringify(user));

        context.setAccessToken(access_token); // استفاده از تابع جدید
        context.setUser(user);
      } catch (error) {
        console.error("Login failed:", error);
        throw error;
      } finally {
        context.setIsLoading(false);
      }
    },
    [context]
  );

  const register = useCallback(
    async (data: RegisterData) => {
      try {
        context.setIsLoading(true);
        const { access_token, user } = await authApi.register(data);

        localStorage.setItem("access_token", access_token);
        localStorage.setItem("user", JSON.stringify(user));

        context.setAccessToken(access_token);
        context.setUser(user);
      } catch (error) {
        console.error("Registration failed:", error);
        throw error;
      } finally {
        context.setIsLoading(false);
      }
    },
    [context]
  );

  const logout = useCallback(() => {
    clearAuthSession();
    context.setAccessToken(null); // استفاده از تابع جدید
    context.setUser(null);
  }, [context]);

  return {
    ...context,
    login,
    register,
    logout,
  };
};
